module.exports = __webpack_public_path__ + "img/tinder.d7d34188.svg";